/** `updatedAt` from the API is ISO-8601 UTC. Show that instant in the player's timezone. */
export function formatClientVersionLocal(updatedAt: string, locale: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/.test(updatedAt)) return null;
  const time = Date.parse(updatedAt);
  if (Number.isNaN(time)) return null;
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(time);
}
